import {feedback_position} from './app.js';

try {
    var course_id = location.pathname.match(/course\/([0-9]{1,})/)[1] ?? 0;
} catch (e) {
    var course_id = 0;
}

function loadticks() {
}

if (location.href.match(/\/(add|edit)-course\//)) {
    $(document).on('click', '.arrow_up', function () {

        var parent = $(this).parents('.lesson');
        var el_curr = $(parent);
        $(el_curr).find('[name]:not([name="marathon[]"]):not([name="marathon_time[]"])').each(function (index) {
            var elnext = $(parent).prev().find('[name]:not([name="marathon[]"]):not([name="marathon_time[]"])').eq(index);
            var namevalnext = elnext.attr('name');
            var currval = $(this).attr('name');

            elnext.attr('name', currval);
            $(this).attr('name', namevalnext);

        });

        $(el_curr).find('[name][type="hidden"]:not([name="marathon[]"]):not([name="marathon_time[]"])').each(function (index) {
            var elnext = $(parent).prev().find('[name][type="hidden"]:not([name="marathon[]"]):not([name="marathon_time[]"])').eq(index);
            var namevalnext = elnext.val();
            var currval = $(this).val();

            elnext.attr('value', currval);
            $(this).attr('value', namevalnext);
        });

        var preview_as_student_curr = $(el_curr).find('.preview_as_student');
        var lesson_route_curr = preview_as_student_curr.data('lesson-route');
        var lesson_number_curr = preview_as_student_curr.data('lesson-number');

        var preview_as_student_next = $(parent).prev().find('.preview_as_student');
        var lesson_route_next = preview_as_student_next.data('lesson-route');
        var lesson_number_next = preview_as_student_next.data('lesson-number');

        preview_as_student_next.attr('data-lesson-number', lesson_number_curr);
        preview_as_student_next.attr('href', lesson_route_curr + '/open/' + lesson_number_curr);

        preview_as_student_curr.attr('data-lesson-number', lesson_number_next);
        preview_as_student_curr.attr('href', lesson_route_next + '/open/' + lesson_number_next);

        $(parent).after($(parent).prev());
        $('.toggle_lesson_marathon').prop('checked', false);
        $('.lesson_marathon_toggle').removeClass('active');
        $('.lesson_marathon_toggle:eq(0)').addClass('active');

        $('.lesson_marathon_toggle').each(function (i) {
            $(this).attr('index', i);
        });

    });

    $(document).on('click', '.arrow_down', function () {
        var parent = $(this).parents('.lesson');
        var el_curr = $(parent);

        $(el_curr).find('[name]:not([name="marathon[]"]):not([name="marathon_time[]"])').each(function (index) {
            var elnext = $(parent).next().find('[name]:not([name="marathon[]"]):not([name="marathon_time[]"])').eq(index);
            var namevalnext = elnext.attr('name');
            var currval = $(this).attr('name');

            elnext.attr('name', currval);
            $(this).attr('name', namevalnext);

            console.log($(this).attr('name'));
        });

        $(el_curr).find('[name][type="hidden"]:not([name="marathon[]"]):not([name="marathon_time[]"])').each(function (index) {
            var elnext = $(parent).next().find('[name][type="hidden"]:not([name="marathon[]"]):not([name="marathon_time[]"])').eq(index);
            var namevalnext = elnext.val();
            var currval = $(this).val();

            elnext.attr('value', currval);
            $(this).attr('value', namevalnext);
        });

        var preview_as_student_curr = $(el_curr).find('.preview_as_student');
        var lesson_route_curr = preview_as_student_curr.data('lesson-route');
        var lesson_number_curr = preview_as_student_curr.data('lesson-number');

        var preview_as_student_next = $(parent).next().find('.preview_as_student');
        var lesson_route_next = preview_as_student_next.data('lesson-route');
        var lesson_number_next = preview_as_student_next.data('lesson-number');

        preview_as_student_next.attr('data-lesson-number', lesson_number_curr);
        preview_as_student_next.attr('href', lesson_route_curr + '/open/' + lesson_number_curr);

        preview_as_student_curr.attr('data-lesson-number', lesson_number_next);
        preview_as_student_curr.attr('href', lesson_route_next + '/open/' + lesson_number_next);

        $(parent).next().after(el_curr);
        $('.toggle_lesson_marathon').prop('checked', false);
        $('.lesson_marathon_toggle').removeClass('active');
        $('.lesson_marathon_toggle:eq(0)').addClass('active');
        $('.lesson_marathon_toggle').each(function (i) {
            $(this).attr('index', i);
        });
    });
}

if (location.href.match(/\/(add|edit)-course\//) || location.href.match(/\/edit-mini-landing\//)
    || location.href.match(/\/webinar-edit\//)
    || location.href.match(/\/autowebinar-edit\//)) {

    /*видео показ ошибка - фикс*/
    const SEARCH_DELAY = 300; // in ms
    let text_error = $('html').attr('lang') === 'ru' ? 'Видео обрабатывается, ожидайте' : 'The video is being processed, please wait';

    function waitForElementToBeAdded() {
        const interval = setInterval(() => {
            var element = $('video:not(.isadded):eq(0)')
            if (element.length) {
                console.log('new_video', element, element[0].readyState);
                $(element[0]).on('error', function (e) {
                    var buh = setInterval(function () {
                        if ($(e.currentTarget).height() != 0) {
                            var par = $(e.currentTarget).parent();
                            console.log('vid', e.currentTarget, par, par.height());
                            par.find('.alerm').remove();
                            par.append(`<span class="alerm" style='
							position: absolute;
							left: 0px;
							top: 0%;
							text-align: center;
							height: ${$(e.currentTarget).height()}px;
							width: 100%;
							color: black;
							background-color: white;
							padding: ${$(e.currentTarget).height() / 2}px 0px;
							opacity: 0.9;
							border: 1px solid red;'>${text_error}</span>`);
                            clearInterval(buh);
                        }
                    }, 100);
                    console.log("error", e);
                });
                $(element).addClass('isadded');
            }
        }, SEARCH_DELAY);

        $(window).on('resize', function () {
            $('.alerm').each(function () {
                var video = $(this).parents('.ckeditor-html5-videojs').find('video');
                $(this).css('height', video.height() + 'px').css('padding', (video.height() / 2) + 'px 0px')
            });

        });
    }

    waitForElementToBeAdded();
    /*видео показ ошибка - фикс*/


    /*рассрочка ченджеры*/

    $('select[name="count_rassroch"]').on('change paste keyup cut copy', function () {
        //let num_lessons = $('#lessons .lessons .lesson').length;
        let count_etaps = $('select[name="count_rassroch"]').val();
        $('.rassroch_percent').val(Math.ceil(100 / count_etaps));
        if ('1' === count_etaps) {
            $('[name="rassroch_by_default"]').prop('checked', false).prop('disabled', true);
        } else {
            $('[name="rassroch_by_default"]').prop('disabled', false);
        }
    });
    $('[name="price_course"],[name="price_without_support"]').on('change paste keyup cut copy', function () {
        let price_course = $('[name="price_course"]').val();
        let price_without_support = $('[name="price_without_support"]').val();

        if ((isNaN(parseInt(price_course)) == false && price_course > 0) || (isNaN(parseInt(price_without_support)) == false && price_without_support > 0)) {
            $('#course_rassroch').show();
        } else {
            $('#course_rassroch').hide();
            $('select[name="count_rassroch"]').val(1).trigger("change");//сброс на дефолт
        }
    });
    /*рассрочка ченджеры*/


}

function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}


if (typeof ($(".ui-sortable").slick) == "function" && typeof ($('.slick-slider').slick) == "function" && !location.href.match(/\/edit-mini-landing\//)) {
    $(".ui-sortable").not('.slick-initialized').slick({
        //TODO::FIX Carousel slide padding
        dots: true,
        infinite: true,
        speed: 100,
        centerMode: true,
        slidesToScroll: 1,
        centerPadding: '120px',
        slidesToShow: 1,
        arrows: false,
        autoplay: false,
        //adaptiveHeight: true
    });

    $('.slick-slider').not('.slick-initialized').slick({
        //TODO::FIX Carousel slide padding
        dots: true,
        infinite: true,
        speed: 150,
        autoplaySpeed: 3000,
        centerMode: true,
        slidesToScroll: 1,
        centerPadding: '120px',
        slidesToShow: 1,
        arrows: false,
        autoplay: false,
        //adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 450,
                settings: {
                    centerPadding: '60px',
                }
            },
        ]
    });

    function come(elem) {
//alert($(elem).offset());
        var docViewTop = $(window).scrollTop(),
            docViewBottom = docViewTop + $(window).height(),
            elemTop = ($(elem).offset() !== null && $(elem).offset() !== undefined) ? $(elem).offset().top : 0,
            elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    var stt = setInterval(function () {
        if (come(".slick-slider")) {
            $('.slick-slider').slick('slickGoTo', 1);
            $('.slick-slider').slick('slickSetOption', 'autoplay', true, true);
            clearInterval(stt);
        }
    }, 200);
}
if (typeof ($(".ui-sortable").sortable) == "function") {
    $(".ui-sortable").sortable({
        change: function (event, ui) {
            typeof autoSave === "function" && autoSave();
        }
    });
}


(function ($) {
    $.fn.fileuploadTus = function (object) {
        function splitFilename(filename) {
            var dot = filename.lastIndexOf('.');
            if (dot === -1 || dot === 0) {
                return '';
            }
            return filename.substr(dot + 1);
        }

        function variableornot(varia1, varianew) {
            return varianew == null ? varia1 : varianew;
        }

        var variable = {};
        var tusUrl = object['tusUrl'];
        var allowedTypes = object['allowedTypes'] ?? false;
        var allowedExt = object['allowedExt'] ?? false;
        var errors_custom = object['errors_custom'] ?? false;
        var lang = object['lang'] ?? 'en';
        var maxFileSize = object['maxFileSize'] ?? 2097152000;
        var change_trigger_active = object['change_trigger_active'] ?? true;
        var remove_fileinput = object['remove_fileinput'] ?? false;
        var callbacks = object['callbacks'] ??
            {
                'onBeforeRequest': function () {
                },
                'onProgress': function (bytesUploaded, bytesTotal, progressbar = null) {
                },
                'onSuccess': function (upload_path, original_name, file_size, progressbar = null) {
                },
                'readedFile': function (file) {
                },
                'abort': function (progressbar) {
                }
            };


        let parentFrom = location.href;

        if (typeof (tus.Upload) != "function") {
            console.warn('need require tus-js-client');
            return this;
        }

        if (typeof (tusUrl) != "string") {
            console.warn('Type of tusUrl is not valid');
            return this;
        }

        if (typeof (maxFileSize) != "number" || maxFileSize <= 0) {
            console.warn('maxFileSize is not valid');
            return this;
        }

        if ($('[data-whash]').length) {
            parentFrom = location.href + '/' + $('[data-whash]').data('whash');
        }


        let errors = {
            'ru': {
                'typenotallowed': errors_custom?.ru?.typenotallowed ?? 'Неверный формат файла',
                'errorload': errors_custom?.ru?.errorload ?? 'Ошибка загрузки файла',
                'retryloadfiles': errors_custom?.ru?.retryloadfiles ?? 'Попробовать ещё раз файл загрузить',
                'maxFileSize': errors_custom?.ru?.maxFileSize ?? `Превышен макс объем файла в ${maxFileSize} байт`
            },
            'en': {
                'typenotallowed': errors_custom?.en?.typenotallowed ?? 'Invalid file format',
                'errorload': errors_custom?.en?.errorload ?? 'File upload error',
                'retryloadfiles': errors_custom?.en?.retryloadfiles ?? 'Try uploading the file again',
                'maxFileSize': errors_custom?.en?.maxFileSize ?? `File size exceeds the maximum limit of ${maxFileSize} bytes`
            }
        }
        var that = this;
        var upload = null;


        function bbtt(that) {

            if (upload != null) {
                upload.abort();
                upload = null;
                $(that).val(null);
            }

            let file = $(that)[0].files[0];
            if (!file) {
                $(that).val(null);
                return;
            }

            let ext = splitFilename(file.name);
            variable = variableornot(variable, callbacks['readedFile'](file, variable));
            $(this).off('abort.fileuploadTus', that).on('abort.fileuploadTus', function (e) {
                if (upload != null) {
                    upload.abort();
                    upload = null;
                    $(that).val(null);
                    variable = variableornot(variable, callbacks['abort'](variable));
                    if (remove_fileinput)
                        $(that).remove();
                }
            });

            let allowedExt_trigger_error = false;
            let allowedTypes_trigger_error = false;
            if (allowedExt !== false)
                allowedExt_trigger_error = allowedExt.indexOf(ext) === -1;

            if (allowedTypes !== false) {
                try {
                    var cuttype = file.type.match('(.*?)\/')[1]
                } catch (e) {
                    var cuttype = '';
                }
                allowedTypes_trigger_error = allowedTypes.indexOf(cuttype) === -1;
            }

            if (allowedTypes_trigger_error || allowedExt_trigger_error) {
                swal({
                    text: errors[lang]['typenotallowed'],
                    icon: 'error'
                }).then(function () {
                    callbacks['abort'](variable);
                });
                $(that).val(null);
                if (remove_fileinput)
                    $(that).remove();
                return;
            }

            if (file.size > maxFileSize) {
                swal({
                    text: errors[lang]['maxFileSize'],
                    icon: 'error'
                }).then(function () {
                    callbacks['abort'](variable);
                });
                $(that).val(null);
                if (remove_fileinput)
                    $(that).remove();
                return;
            }

            var options = {
                endpoint: tusUrl,
                chunkSize: 5242880,
                retryDelays: [0, 3000, 5000, 10000, 20000],
                parallelUploads: 1,
                metadata: {
                    filename: file.name.replace(" ", "-").replace("#", ""),
                    filetype: file.type,
                    course_id: location.href.match(/(edit|add)-course\/([0-9]{1,})/)[2]
                },
                onError: function (error, b, c) {
                    console.log(error);
                    console.log(error.originalRequest);
                    if (error.originalRequest) {
                        if (window.confirm(errors[lang]['retryloadfiles'])) {
                            upload.start();
                            return;
                        }
                    } else {
                        console.log('eerrr', error.originalRequest);
                        swal({
                            text: errors[lang]['errorload'],
                            icon: 'error'
                        }).then(function () {
                            callbacks['abort'](variable);
                        });
                    }
                    upload = null;
                    $(that).val(null);
                    if (remove_fileinput)
                        $(that).remove();
                },
                onBeforeRequest: function () {
                    variable = variableornot(variable, callbacks['onBeforeRequest'](variable));
                },
                onProgress: function (bytesUploaded, bytesTotal) {
                    variable = variableornot(variable, callbacks['onProgress'](bytesUploaded, bytesTotal, variable));
                },
                onSuccess: function () {
                    let upload_path = upload._req._xhr.getResponseHeader('_upload_name').split(',')[0];
                    let original_name = file.name;
                    let file_size = file.size;
                    variable = variableornot(variable, callbacks['onSuccess'](upload_path, original_name, file_size, variable));
                    upload = null;
                    $(that).val(null);
                    if (remove_fileinput)
                        $(that).remove();
                }
            };
            upload = new tus.Upload(file, options);
            upload.start();
        }

        if (change_trigger_active) {

            $(that).off('change').on('change', function () {
                bbtt(that);
            });
        } else {
            bbtt(that);
        }
        return this;
    };
})(jQuery);


$(document).on('click', '.remove-slide', function () {
    $(this).parent().remove();
    typeof autoSave === "function" && autoSave();
});
$('#add-slide-slider_editcourse').fileuploadTus(
    {
        'tusUrl': '/editcourseimage-tus/1',
        'allowedTypes': ['image'],
        'allowedExt': false,
        'lang': current_lang,
        'change_trigger_active': true,
        'callbacks': {
            'abort': function (variable) {
                $('.add-slide-slider_editcourse').removeAttr('disabled');
            },
            'onBeforeRequest': function () {
            },
            'onProgress': function (bytesUploaded, bytesTotal, variable) {
            },
            'onSuccess': function (upload_path, original_name, file_size, variable) {
                $('.add-slide-slider_editcourse').removeAttr('disabled');
                console.log(upload_path, original_name, file_size, variable);
                var urlloaded = 'https://educate.market/' + upload_path;
                $('.slider-order').append(`
				<li class="item ui-sortable-handle" data-id="dOgThsz" src="${urlloaded}" style="background-image: url('${urlloaded}'); position: relative; left: 0px; top: 0px;">
					<span class="btn btn-danger delete-slide btn-sm remove-slide" tabindex="-1"><i class="fa fa-trash fa-sm"></i></span>
				</li>
				`);
                typeof autoSave === "function" && autoSave();
            },
            'readedFile': function (file, variable) {
                console.log('loaded', file, variable);
                $('.add-slide-slider_editcourse').attr('disabled', 'disabled');
                return variable;
            }
        }
    });
$('.opnauth[data-target="#modalAuth"]').on('click', function () {
    if (!$('.modal-body-auth').find('form')[0].hasAttribute("action_orig")) {
        $('.modal-body-auth').find('form').attr('action_orig', $('.modal-body-auth').find('form').attr('action'));
    }
    $('.modal-body-auth').find('form').attr('action', $('.modal-body-auth').find('form').attr('action') + "?tobuy=" + ($('input[name="course_price"]:checked').val() === '0' ? 'with_support' : 'without_support'));
    $('.social-auth a').each(function () {
        $(this).attr('href', $(this).attr('href') + "?tobuy=" + ($('input[name="course_price"]:checked').val() === '0' ? 'with_support' : 'without_support'));
    });
    $('.modal-body-reg-fields').find('form').attr('action', $('.modal-body-reg-fields').find('form').attr('action') + "?tobuy=" + ($('input[name="course_price"]:checked').val() === '0' ? 'with_support' : 'without_support'));
});
$('[data-target="#modalAuth"]:not(.opnauth)').on('click', function () {
    if ($('.modal-body-auth').find('form')[0].hasAttribute("action_orig")) {
        $('.modal-body-auth').find('form').attr('action', $('.modal-body-auth').find('form').attr('action_orig'));
    }
    $('.social-auth a').each(function () {
        $(this).attr('href', $(this).attr('href').replace("?tobuy=" + ($('input[name="course_price"]:checked').val() === '0' ? 'with_support' : 'without_support'), ''));
    });
    $('.modal-body-reg-fields').find('form').attr('action', $('.modal-body-reg-fields').find('form').attr('action').replace("?tobuy=" + ($('input[name="course_price"]:checked').val() === '0' ? 'with_support' : 'without_support'), ''));
});

$('#upload_course_image').fileupload({
    url: '/upload/course_image/' + $('#upload_course_image').attr('data-id'),
    acceptFileTypes: /(\.|\/)(jpe?g|png)$/i,
    maxFileSize: 12000000,
    multiple: false,
    dataType: 'json',
    single: true,
    dropZone: $(".course-bg-upload"),
    add: function (e, data) {
        $(".course-bg-upload").removeClass('uploaded').addClass('uploading').removeAttr('style');
        if (typeof updateCourseBackgroundImage !== 'undefined') {
            var reader = new FileReader();
            reader.onload = function (e) {
                typeof updateCourseBackgroundImage !== 'undefined' && updateCourseBackgroundImage(e.target.result, data);
            };
            reader.onerror = function (e) {
                $('#upload_course_image').next().val('');
                data.submit();
            };
            reader.readAsDataURL(data.files[0]);
        } else {
            $('#upload_course_image').next().val('');
            data.submit();
        }
    },
    done: function (e, data) {
        console.log(data.result);
        $(".course-bg-upload").removeClass('uploading').addClass('uploaded');
        $(".course-bg-upload").css({'background-image': 'url(' + data.result.url + '?_' + Math.random() + ')'});
        $('#upload_course_image').next().val(data.result.path).trigger('change');
        typeof updateCourseBackgroundImageDone !== 'undefined' && updateCourseBackgroundImageDone(data);
    },
    progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
    },
    fail: function (e, data) {
        try {
            console.log(data, data.jqXHR, data.jqXHR.responseJSON);
            swal({
                text: data.jqXHR.responseJSON.errors.file[0],
                icon: 'error'
            }).then(function () {
            });
        } catch (e) {
            swal({
                text: $('html').attr('lang') === 'ru' ? "Ошибка загрузки" : "Error uploading",
                icon: 'error'
            }).then(function () {
            });
        }
        $(".course-bg-upload").removeClass('uploading').removeClass('uploaded').removeAttr('style');
    }
});
$('#upload_course_teacher_photo').fileupload({
    acceptFileTypes: /(\.|\/)(jpe?g|png)$/i,
    maxFileSize: 12000000,
    multiple: false,
    dataType: 'json',
    single: true,
    add: function (e, data) {
        data.url = '/upload/teacher_photo/' + parseInt($('#modal_curator input[name="id"]').val());
        $(".course-teacher-upload").removeClass('uploaded').addClass('uploading');
        $(".course-teacher-upload div").removeAttr('style');
        $(".course-teacher-upload svg").show();
        $('#upload_course_teacher_photo').next().val('');
        data.submit();
    },
    done: function (e, data) {
        $(".course-teacher-upload div").css({'background-image': 'url(' + data.result.url + '?_' + Math.random() + ')'});
        $('#upload_course_teacher_photo').next().val(data.result.path);
        $(".course-teacher-upload svg").hide();
    },
    progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
    },
    fail: function (e, data) {
        try {
            console.log(data, data.jqXHR, data.jqXHR.responseJSON);
            swal({
                text: data.jqXHR.responseJSON.errors.file[0],
                icon: 'error'
            }).then(function () {
            });
        } catch (e) {
            swal({
                text: $('html').attr('lang') === 'ru' ? "Ошибка загрузки" : "Error uploading",
                icon: 'error'
            }).then(function () {
            });
        }
        $(".course-teacher-upload").removeClass('uploading').removeClass('uploaded').removeAttr('style');
    }
});
$(document).bind('dragover', function (e) {
    var dropZone = $(".course-bg-upload"),
        timeout = window.dropZoneTimeout;
    if (timeout) {
        clearTimeout(timeout);
    } else {
        dropZone.addClass('in');
    }
    var hoveredDropZone = $(e.target).closest(dropZone);
    dropZone.toggleClass('hover', hoveredDropZone.length);
    window.dropZoneTimeout = setTimeout(function () {
        window.dropZoneTimeout = null;
        dropZone.removeClass('in hover');
    }, 100);
});

function update_courses_marathon_checkboxes() {
    var obj = $('.lesson_marathon_toggle:eq(0)');
    if ($(obj).find('input[type="checkbox"]').is(':checked')) {
        $('.lesson_marathon_toggle').each(function () {
            if (!$(this).find('input[type="checkbox"]').is(':checked')) {
                return false;
            } else {
                obj = $(this);
            }
        });
    } else {
        obj = $;
    }

    var index = parseInt(obj.attr('index'));
    index = isNaN(index) ? -1 : index;
    $('.lesson_marathon_toggle').each(function () {
        if (parseInt($(this).attr('index')) > index + 1 || $(this).attr('index') >= 5) {
            $(this).removeClass('active');
            $(this).find('input[type="checkbox"]').prop('checked', false);
        } else {
            $(this).addClass('active');
        }
    });

    $('.lesson_marathon_available_toggle').each(function () {
        if (parseInt($(this).attr('index')) > index + 1 || $(this).attr('index') >= 5) {
            $(this).removeClass('active');
        }
    });
}


$(document).on('click', '.add-lesson', function (e) { // TODO: в CKEDITOR.instances дубли=глюки
    e.stopImmediatePropagation();
    e.preventDefault();

    $('body').append('<div class="modal-backdrop fade show"></div>');
    let modalLoading = $('#modalLoading');
    modalLoading.addClass('show').css('display', 'block');

    let prevLesson = $('.lessons .lesson:last-child');
    let prevLessonId = prevLesson.find('.lesson-collapse').data('id');
    let prevLessonCollapse = $('#lesson' + prevLessonId);
    let prevLessonNeedHide = false;
    if (!prevLessonCollapse.hasClass('show')) {
        prevLessonCollapse.addClass('show');
        prevLessonNeedHide = true;
    }

    const ckeTimerInterval = 200;
    const animationSpeed = 300;
    let ckeIsLoaded = false;

    let prevLessonHomeworkNeedHide = false;
    if (!$('#add-task-field-row-' + prevLessonId).hasClass('show')) {
        prevLessonHomeworkNeedHide = true;
        // setTimeout(() => $('#add-task-field-row-'+prevLessonId).addClass('show'), 200);
        $('#add-task-field-row-' + prevLessonId).addClass('show');
    }

    // скроллы нужны для инициации ленивой загрузки CKEDITOR
    // document.getElementById('add-lesson').scrollIntoView();
    // document.getElementById('lesson-wrapper' + prevLessonId).scrollIntoView();
    $([document.documentElement, document.body]).animate({
            scrollTop: $("#add-lesson").offset().top
        },
        animationSpeed,
        () => {

            let scrolledToAddLesson = false;

            // интервал нужен для ожидания конца инициации ленивой загрузки CKEDITOR
            let timerId = setInterval(() => {

                if (ckeIsLoaded) {
                    clearInterval(timerId);
                }

                let lesson = $('.lessons .lesson:last-child').clone();

                let cke_editableEls = lesson.find('.cke_editable ');

                // если оба блока CKEDITOR загрузились, то отрисовываем новый урок
                if (2 === cke_editableEls.length && !ckeIsLoaded && scrolledToAddLesson) {
                    ckeIsLoaded = true;
                    clearInterval(timerId);

                    let key = _.random(10000, 999999);
                    let preview_as_student = lesson.find('.preview_as_student');
                    let lesson_route = preview_as_student.data('lesson-route');
                    let lesson_number = preview_as_student.data('lesson-number') + 1;

                    preview_as_student.attr('data-lesson-number', lesson_number);
                    preview_as_student.attr('href', lesson_route + '/open/' + lesson_number);

                    let lesson_collapse = lesson.find('.lesson-collapse');
                    let lesson_collapse_id_old = lesson_collapse.data('id');
                    let lesson_collapse_id = lesson_collapse_id_old + 1;

                    lesson_collapse
                        .attr('data-id', lesson_collapse_id)
                        .attr('href', '#lesson' + lesson_collapse_id)
                        .attr('aria-controls', 'lesson' + lesson_collapse_id)
                        .attr('aria-expanded', 'true');

                    lesson.attr('id', 'lesson-wrapper' + lesson_collapse_id);

                    lesson.find('.multi-collapse').attr('id', 'lesson' + lesson_collapse_id).addClass('show');

                    lesson.find('input[type="text"],input[type="hidden"],textarea').val('');
                    lesson.find('label[id^="lesson-title"]').text('');
                    lesson.find('input[type="checkbox"]').prop('checked', false);
                    lesson.find('.link_for_funnel').hide();
                    lesson.find('.link_for_collapse').hide();
                    lesson.find('.lesson-module-toggle').hide();
                    lesson.find('.uploadBlock').remove();
                    lesson.find('.lesson_marathon_toggle').removeClass('active');
                    lesson.find('.lesson_marathon_toggle').attr('index', parseInt($('.lesson_marathon_toggle:last').attr('index')) + 1);
                    lesson.find('input,textarea').each(function () {
                        $(this).attr('name', $(this).attr('name').replace(/\[(|(\d+))\]/, '[' + key + ']'));
                    });
                    //lesson.find('textarea').addClass('cke_editable');
                    lesson.find('input[data-link]').attr('data-link', 'link_' + key);
                    lesson.find('.copy[data-clipboard-target]').attr('data-clipboard-target', 'input[data-link=\'link_' + key + '\']');

                    lesson.find('.add-task-btn-row').addClass('show');
                    lesson.find('.add-task-btn-row').attr('id', 'add-task-btn-row-' + key);
                    lesson.find('.add-task-field-row').removeClass('show');
                    lesson.find('.add-task-field-row').attr('id', 'add-task-field-row-' + key);
                    lesson.find('.add-task-btn').attr('data-task-number', key);

                    cke_editableEls.each(function () {
                        let prev = $(this).prev();
                        $(this).remove();
                        prev.prev().html('');
                        CKEDITOR.inline(prev[0], {
                            toolbar: [
                                {name: 'clipboard', groups: ['clipboard', 'undo'], items: ['Undo', 'Redo']},


                                {
                                    name: 'basicstyles',
                                    groups: ['basicstyles', 'cleanup'],
                                    items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting']
                                },
                                {
                                    name: 'paragraph',
                                    groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
                                    items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
                                },
                                {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
                                {name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley',]},
                                {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
                                {name: 'colors', items: ['TextColor', 'BGColor']},
                                {name: 'tools', items: ['Maximize', 'ShowBlocks']},
                                {name: 'others', items: ['-']},
                                {
                                    name: 'insert',
                                    items: ['Image', '-', 'Youtube', '-', 'CodeSnippet', '-', 'FileUrl', '-', 'Audio', '-', 'Video2', 'videomulti', '-', 'record_voice', '-', 'html5audio']
                                },
                            ],
                            sharedSpaces: {
                                top: prev.prev()[0]
                            },
                            filebrowserUploadUrl: '/upload/course_content_image/' + $('#course_presentation_editor').attr('data-id') + '?',
                            filebrowserUploadMethod: 'form',
                            extraPlugins: 'confighelper,youtube,video,widget,widgetselection,clipboard,lineutils,sharedspace,justify,colorbutton,codesnippet,video2,fileurl,audio,videomulti,record_voice,html5audio',
                            removePlugins: 'floatingspace,maximize,resize',
                            youtube_responsive: true,
                            allowedContent: true,
                            resize_dir: 'vertical',
                            language: $('html').attr('lang')
                        }).on('change', function (e) {
                            $(e.editor.element.$).removeClass('valid-feedback').removeClass('invalid-feedback').removeClass('is-invalid');
                            $(e.editor.element.$).next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
                        });
                    })
                    $('.lessons').append(lesson);
                    lesson.find('.copy[data-clipboard-target]').popover({
                        'template': '<div class="popover popover-style" role="tooltip"><div class="popover-body"></div></div>',
                        'placement': $(this).data('placement') ?? 'top',
                        'trigger': 'click'
                    }).on('shown.bs.popover', function (e) {
                        e.stopPropagation();
                        let current_popover = '#' + $(e.target).attr('aria-describedby');
                        let $cur_pop = $(current_popover);
                        $cur_pop.find('.popover-body').append('<button type="button" class="close"></button>');
                        $cur_pop.find('.close').click(function (e) {
                            $cur_pop.popover('hide');
                        });
                    });
                    new ClipboardJS(lesson.find('.copy[data-clipboard-target]')[0]);
                    $('[data-link]').each(function (k) {
                        $(this).val($(this).attr('data-url') + '#program=' + (k + 1));
                    });
                    update_courses_marathon_checkboxes();

                    // if (prevLessonNeedHide){
                    //     $('#lesson' + lesson_collapse_id_old).removeClass('show');
                    // }

                    if (prevLessonHomeworkNeedHide) {
                        $('#add-task-field-row-' + prevLessonId).removeClass('show');
                    }

                    document.getElementById('lesson-wrapper' + lesson_collapse_id).scrollIntoView();

                    $('.modal-backdrop').remove();
                    modalLoading.removeClass('show').css('display', 'none').hide();

                    return false;
                } else if (!ckeIsLoaded) {
                    $([document.documentElement, document.body]).animate({
                            scrollTop: $("#add-lesson").offset().top
                        },
                        animationSpeed,
                        () => {
                            scrolledToAddLesson = true;
                        }
                    );
                }
            }, ckeTimerInterval);
        }
    );
});

if ($('html').attr('lang') === 'ru') {
    window.lang = $.extend(window.lang ? window.lang : {}, {
        edit: 'Редактировать',
        deleteHead: 'Вы уверены?',
        deleteOk: 'Удалить',
        deleteCancel: 'Отменить',
        deleteLessonBody: '',
    });
} else {
    window.lang = $.extend(window.lang ? window.lang : {}, {
        edit: 'Edit',
        deleteHead: 'Are you sure?',
        deleteOk: 'Ok',
        deleteCancel: 'Cancel',
        deleteLessonBody: 'Once deleted, you will not be able to recover this lesson!',
    });
}

function removeLesson(element) {
    if ($('.lessons .lesson').length <= 1) {
        $(element).closest('.lesson').find('input,textarea,div[contenteditable="true"]').val('').html('').prop('checked', false);
    } else {
        $(element).closest('.lesson').remove();
    }
    return false;
}

$(document).on('click', '.remove-lesson', function (event) {
    event.preventDefault();
    let element = $(event.currentTarget);
    swal({
        title: window.lang.deleteHead,
        text: window.lang.deleteLessonBody,
        icon: "warning",
        buttons: {
            cancel: {
                text: window.lang.deleteCancel,
                value: null,
                visible: true,
                className: "",
                closeModal: true,
            },
            confirm: {
                text: window.lang.deleteOk,
                value: true,
                visible: true,
                className: "",
                closeModal: true
            }
        },
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete) {
                removeLesson(element);
            } else {

            }
        });
})

$('.show_course_landing').click(function () {
    if (parseInt($('#status').val()) == 0) {
        swal({
            text: window.lang.not_saved,
            icon: 'error'
        }).then(function () {
        });
        return false;
    }
});

String.prototype.replaceAll = function (search, replace) {
    return this.split(search).join(replace);
}

$('input[name="course_price_calc"]').change(function () {
    var checked_inp = $('input[name="course_price"]:checked').val();

    var price = 0;
    var main_price = 0;
    if (checked_inp == "1") {//без куратора
        price = parseFloat($('input[name="course_price"]:checked').parents('label:eq(0)').find('span:eq(1)').html().replaceAll(' ', '').replaceAll('\n', ''));
        main_price = price;
        $(this).parents('.lessons-list.lessons-list-without-curator').find('input[name="course_price_calc"]').each(function () {
            if ($(this).prop('checked')) {
                price += Math.round(parseFloat($(this).val()));
            }
        });
    } else {

        price = parseFloat($('input[name="course_price"]:checked').parents('label:eq(0)').find('span:eq(1)').html().replaceAll(' ', '').replaceAll('\n', ''));
        main_price = price;
        $(this).parents('.lessons-list.lessons-list-with-curator').find('input[name="course_price_calc"]').each(function () {
            if ($(this).prop('checked')) {
                price += Math.round(parseFloat($(this).val()));
            }
        });

        //$(this).closest('.course-modal-info').find('.course_price_calc_result').text(number_format(price, 2, ',', ' '));
    }
    //console.log('estet',price);
    if (price == 0) {
        console.log('amoiunn', price);
        $('.link-pay.btn.btn-block.btn-green').text(translate['pages.courses.need']);
    } else {
        $('.link-pay.btn.btn-block.btn-green').text(translate['pages.courses.want_buy']);
    }
    if (price == 0) {
        $('.bottom-button-fixed .pay-text').text(translate['pages.courses.payfree']);
        $('.bottom-button-fixed .discount').hide();
        console.log('hideasd')
    } else {
        console.log('opensd')
        $('.bottom-button-fixed .pay-text').text(translate['pages.courses.byu_now']);
        if (main_price > 0) {
            $('.bottom-button-fixed .discount span').text($(this).parents('.modal-content').find('[name="course_price"]:checked').siblings('.discount').find('span').text());
            $('.bottom-button-fixed .discount').show();
        }
    }

    $('.bottom-button-fixed .amount span').text(parseInt(price));
});

loadticks();
$('[name=course_price]:checked').eq(0).click();
//первый запуск костыль костыльный
/*$('input[name="course_price_calc"]').each(function(){
	price = parseFloat(($(this).closest('.course-modal-info').find('.course_price_calc_result').data('default')+'').replace(' ', ''));
	$(this).closest('.course-modal-info').find('input[name="course_price_calc"]').each(function (){
		if($(this).prop('checked')){
			price += parseFloat($(this).val());
		}
	});

	$(this).closest('.course-modal-info').find('.course_price_calc_result').text(number_format(price, 2, ',', ' '));
});*/
try {
    var buy_course = location.pathname.match(/course\/([0-9]{1,})/)[1] ?? 0;
} catch (e) {
    var buy_course = 0;
}

if ($('#course_slider_editor').length) {
    var course_slider_editor = CKEDITOR.inline('course_slider_editor', {
        toolbar: [
            {name: 'insert', items: ['Image']},
        ],
        sharedSpaces: {
            top: 'course_slider_editor_toolbar'
        },
        filebrowserUploadUrl: '/upload/course_content_image/' + $('#course_slider_editor').attr('data-id') + '?',
        filebrowserUploadMethod: 'form',
        extraPlugins: 'confighelper,youtube,widget,widgetselection,clipboard,lineutils,sharedspace,justify,codesnippet,video2',
        removePlugins: 'floatingspace,maximize,resize',
        youtube_responsive: true,
        allowedContent: true,
        resize_dir: 'vertical',
        protectedSource: /<span.*class="my-break-point".*\/>/g,
        language: $('html').attr('lang')
    }).on('change', function (e) {
        $(e.editor.element.$).removeClass('valid-feedback').removeClass('invalid-feedback').removeClass('is-invalid');
        $(e.editor.element.$).next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
    });
}

if ($('#course_presentation_editor').length) {
    var course_presentation_editor = CKEDITOR.inline('course_presentation_editor', {
        toolbar: [

            {name: 'clipboard', groups: ['clipboard', 'undo'], items: ['Undo', 'Redo']},


            {
                name: 'basicstyles',
                groups: ['basicstyles', 'cleanup'],
                items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting']
            },
            {
                name: 'paragraph',
                groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
                items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
            },
            {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
            {name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley',]},
            {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
            {name: 'colors', items: ['TextColor', 'BGColor']},
            {name: 'tools', items: ['Maximize', 'ShowBlocks']},
            {name: 'others', items: ['-']},
            {
                name: 'insert',
                items: ['Image', '-', 'Youtube', '-', 'CodeSnippet', '-', 'Video2', 'videomulti', '-', 'record_voice', '-', 'html5audio']
            },
        ],
        sharedSpaces: {
            top: 'course_presentation_editor_toolbar'
        },
        filebrowserUploadUrl: '/upload/course_content_image/' + $('#course_presentation_editor').attr('data-id') + '?',
        filebrowserUploadMethod: 'form',
        extraPlugins: 'confighelper,youtube,widget,widgetselection,clipboard,lineutils,sharedspace,justify,codesnippet,video2,videomulti,record_voice,html5audio,colorbutton',
        removePlugins: 'floatingspace,maximize,resize',
        youtube_responsive: true,
        allowedContent: true,
        resize_dir: 'vertical',
        protectedSource: /<span.*class="my-break-point".*\/>/g,
        language: $('html').attr('lang')
    }).on('change', function (e) {
        console.log('Log');
        $(e.editor.element.$).removeClass('valid-feedback').removeClass('invalid-feedback').removeClass('is-invalid');
        $(e.editor.element.$).next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
    });
    var course_specification_editor = CKEDITOR.inline('course_specification_editor', {
        toolbar: [
            {name: 'clipboard', groups: ['clipboard', 'undo'], items: ['Undo', 'Redo']},


            {
                name: 'basicstyles',
                groups: ['basicstyles', 'cleanup'],
                items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting']
            },
            {
                name: 'paragraph',
                groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
                items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
            },
            {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
            {name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley',]},

            {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
            {name: 'colors', items: ['TextColor', 'BGColor']},
            {name: 'tools', items: ['Maximize', 'ShowBlocks']},
            {name: 'others', items: ['-']},
            {
                name: 'insert',
                items: ['Image', '-', 'Youtube', '-', 'CodeSnippet', '-', 'Video2', 'videomulti', '-', 'record_voice', '-', 'html5audio', 'FileUrl', 'Audio']
            },
        ],
        sharedSpaces: {
            top: 'course_specification_editor_toolbar'
        },
        filebrowserUploadUrl: '/upload/course_content_image/' + $('#course_specification_editor').attr('data-id') + '?',
        filebrowserUploadMethod: 'form',
        extraPlugins: 'confighelper,youtube,widget,widgetselection,clipboard,lineutils,sharedspace,justify,codesnippet,video2,videomulti,record_voice,html5audio,fileurl,audio,colorbutton',
        removePlugins: 'floatingspace,maximize,resize',
        youtube_responsive: true,
        allowedContent: true,
        resize_dir: 'vertical',
        protectedSource: /<span.*class="my-break-point".*\/>/g,
        language: $('html').attr('lang')
    }).on('change', function (e) {
        $(e.editor.element.$).removeClass('valid-feedback').removeClass('invalid-feedback').removeClass('is-invalid');
        $(e.editor.element.$).next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
    });
    var course_certification_editor = CKEDITOR.inline('course_certification_editor', {
        toolbar: [
            {name: 'clipboard', groups: ['clipboard', 'undo'], items: ['Undo', 'Redo']},


            {
                name: 'basicstyles',
                groups: ['basicstyles', 'cleanup'],
                items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting']
            },
            {
                name: 'paragraph',
                groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
                items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
            },
            {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
            {name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley',]},
            '/',
            {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
            {name: 'colors', items: ['TextColor', 'BGColor']},
            {name: 'tools', items: ['Maximize', 'ShowBlocks']},
            {name: 'others', items: ['-']},
            {
                name: 'insert',
                items: ['Image', '-', 'Youtube', '-', 'CodeSnippet', '-', 'Video2', 'videomulti', '-', 'record_voice', '-', 'html5audio', 'FileUrl', 'Audio']
            },
        ],
        sharedSpaces: {
            top: 'course_certification_editor_toolbar'
        },
        filebrowserUploadUrl: '/upload/course_content_image/' + $('#course_certification_editor').attr('data-id') + '?',
        filebrowserUploadMethod: 'form',
        extraPlugins: 'confighelper,youtube,video,widget,widgetselection,clipboard,lineutils,sharedspace,justify,codesnippet,video2,videomulti,record_voice,html5audio,fileurl,audio,colorbutton',
        removePlugins: 'floatingspace,maximize,resize',
        youtube_responsive: true,
        allowedContent: true,
        resize_dir: 'vertical',
        language: $('html').attr('lang')
    }).on('change', function (e) {
        $(e.editor.element.$).removeClass('valid-feedback').removeClass('invalid-feedback').removeClass('is-invalid');
        $(e.editor.element.$).next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
    });


    var consult_tu_editor = CKEDITOR.inline('consult_tu_editor', {
        toolbar: [
            {name: 'clipboard', groups: ['clipboard', 'undo'], items: ['Undo', 'Redo']},


            {
                name: 'basicstyles',
                groups: ['basicstyles', 'cleanup'],
                items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting']
            },
            {
                name: 'paragraph',
                groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
                items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
            },
            {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
            {name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley',]},

            {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
            {name: 'colors', items: ['TextColor', 'BGColor']},
            {name: 'tools', items: ['Maximize', 'ShowBlocks']},
            {name: 'others', items: ['-']},
            {
                name: 'insert',
                items: ['Image', '-', 'Youtube', '-', 'CodeSnippet', '-', 'Video2', 'videomulti', '-', 'record_voice', '-', 'html5audio', 'FileUrl', 'Audio']
            },
        ],
        sharedSpaces: {
            top: 'consult_tu_toolbar'
        },
        filebrowserUploadUrl: '/upload/course_content_image/' + $('#consult_tu_editor').attr('data-id') + '?',
        filebrowserUploadMethod: 'form',
        extraPlugins: 'confighelper,youtube,video,widget,widgetselection,clipboard,lineutils,sharedspace,justify,codesnippet,video2,videomulti,record_voice,html5audio,fileurl,audio,colorbutton',
        removePlugins: 'floatingspace,maximize,resize',
        youtube_responsive: true,
        allowedContent: true,
        resize_dir: 'vertical',
        language: $('html').attr('lang')
    }).on('change', function (e) {
        $(e.editor.element.$).removeClass('valid-feedback').removeClass('invalid-feedback').removeClass('is-invalid');
        $(e.editor.element.$).next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
    });


    //
    var listInTextParams = {
        toolbar: [],
        resize_dir: 'vertical',
        language: $('html').attr('lang'),
        allowedContent: 'p',
        on: {
            /*instanceReady: function () {
                this.dataProcessor.htmlFilter.addRules({
                    elements: {
                        ul: function (el) {
                            // Add an attribute.
                            if (!el.attributes.class)
                                el.attributes.class = 'An-image';

                            // Add some class.
                            el.addClass('newsleft');
                        }
                    }
                });
            }
            instanceReady: function () {
                this.dataProcessor.dataFilter.addRules({
                    elements: {
                        ul: function (el) {
                            console.log(el);
                            // Add an attribute.
                            if (!el.attributes.class)
                                el.attributes.class = 'An-image';

                            // Add some class.
                            el.addClass('newsleft');
                        }
                    }
                });
            }*/
        }
    };
    var listInTextOnChange = function (e) {
        console.log('LOG rka');
        $(e.editor.element.$).removeClass('valid-feedback').removeClass('invalid-feedback').removeClass('is-invalid');
        $(e.editor.element.$).next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
    };
    CKEDITOR.inline('course_description_editor', listInTextParams).on('change', listInTextOnChange);
    CKEDITOR.inline('course_for_whom_editor', listInTextParams).on('change', listInTextOnChange);

    function ckeInit(elm) {
        console.log('LOG rka2 3');
        CKEDITOR.inline(elm, {
            toolbar: [
                {name: 'clipboard', groups: ['clipboard', 'undo'], items: ['Undo', 'Redo']},


                {
                    name: 'basicstyles',
                    groups: ['basicstyles', 'cleanup'],
                    items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting']
                },
                {
                    name: 'paragraph',
                    groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
                    items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
                },
                {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
                {name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley',]},

                {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
                {name: 'colors', items: ['TextColor', 'BGColor']},
                {name: 'tools', items: ['Maximize', 'ShowBlocks']},
                {name: 'others', items: ['-']},
                {
                    name: 'insert',
                    items: ['Image', '-', 'Youtube', '-', 'CodeSnippet', '-', 'Video2', 'videomulti', '-', 'record_voice', '-', 'html5audio', 'FileUrl', 'Audio']
                },
            ],
            sharedSpaces: {
                top: $(elm).parent().find('.cke_toolbar_top')[0]
            },
            filebrowserUploadUrl: '/upload/course_content_image/' + $('#course_presentation_editor').attr('data-id') + '?',
            filebrowserUploadMethod: 'form',
            extraPlugins: 'confighelper,youtube,video,widget,widgetselection,clipboard,lineutils,sharedspace,justify,codesnippet,video2,videomulti,record_voice,html5audio,fileurl,audio,colorbutton',
            removePlugins: 'floatingspace,maximize,resize',
            youtube_responsive: true,
            allowedContent: true,
            resize_dir: 'vertical',
            language: $('html').attr('lang')
        }).on('change', function (e) {
            $(e.editor.element.$).removeClass('valid-feedback').removeClass('invalid-feedback').removeClass('is-invalid');
            $(e.editor.element.$).next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
        });
    }

    var lazyLoadElementsCKE = document.querySelectorAll(".lazy-cke");
    if (("IntersectionObserver" in window)) {
        var imageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var elm = entry.target;
                    elm.classList.remove("lazy-cke");
                    ckeInit(elm);
                    imageObserver.unobserve(elm);
                }
            });
        });
        lazyLoadElementsCKE.forEach(function (elm) {
            imageObserver.observe(elm);
        });
    } else {
        var lazyLoadThrottleTimeout;

        function lazyLoadThrottleTimeoutClear() {
            if (lazyLoadThrottleTimeout) {
                clearTimeout(lazyLoadThrottleTimeout);
            }

            lazyLoadThrottleTimeout = setTimeout(function () {
                var scrollTop = window.pageYOffset;
                lazyLoadElementsCKE.forEach(function (elm) {
                    if (elm.offsetTop < (window.innerHeight + scrollTop) && elm.classList.contains('lazy-cke')) {
                        elm.classList.remove('lazy-cke');
                        ckeInit(elm);
                    }
                });
                if (lazyLoadElementsCKE.length === 0) {
                    document.removeEventListener("scroll", lazyLoadThrottleTimeoutClear);
                    window.removeEventListener("resize", lazyLoadThrottleTimeoutClear);
                    window.removeEventListener("orientationChange", lazyLoadThrottleTimeoutClear);
                }
            }, 20);
        }

        document.addEventListener("scroll", lazyLoadThrottleTimeoutClear);
        window.addEventListener("resize", lazyLoadThrottleTimeoutClear);
        window.addEventListener("orientationChange", lazyLoadThrottleTimeoutClear);
    }


}
var TopOffset = 51, fixedHeadingOffsetTop = 0;
if ($('body').hasClass('course-landing')) {
    TopOffset = 35;
} else if ($('.fixed-heading').length) {
    TopOffset = $('header').height() + $('.fixed-heading').height();
    fixedHeadingOffsetTop = $('.fixed-heading').parent().offset().top - $('.fixed-heading').height();
}

$('.moveTo a,.moveTo[href]').click(function () {
    console.log(TopOffset);
    var target = $(this).attr('href');
    $(this).addClass('gr');
    if ($(target).length) {
        $('html, body').animate({
            scrollTop: $(target).offset().top - TopOffset
        }, 600);
    }
    return false;
});
var anchors = [];
$('.moveTo a').each(function () {
    if ($($(this).attr('href')).length) {
        anchors.push($(this).attr('href'));
    }
});
$('.fixed-menu .after').click(function () {
    if ($('.moveTo.active').next('.moveTo').length) {
        $('.moveTo.active').next('.moveTo').find('a').trigger('click');
    }
    return false;
});
$(window).scroll(function (e) {
    if (fixedHeadingOffsetTop) {
        if ($(window).scrollTop() >= fixedHeadingOffsetTop) {
            $('.fixed-heading').addClass('sticky');
        } else {
            $('.fixed-heading').removeClass('sticky');
        }
    }
    $.each(anchors, function (i, v) {
        var anchor_offset = $(v).offset().top - ($(v).is(':last-child') ? ($('.course-form').length ? $(window).height() * 0.7 : 0) : 0) - TopOffset - 10;

        if ($(window).scrollTop() >= anchor_offset) {

            $(".moveTo.active").removeClass("active");
            $('a[href="' + v + '"]').parent().addClass("active");


            var prev = $('a[href="' + v + '"]').parent().prev(), offsetLeft = 0;
            while (prev && prev.length) {
                offsetLeft += prev.width() + 20;
                prev = prev.prev();
            }
            $('a[href="' + v + '"]').parent().parent().scrollLeft(offsetLeft);
        }

    });
});

if (document.querySelector('.js-showTeacherPage') != null) {
    document.querySelector('.js-showTeacherPage').addEventListener('click', function () {
        window.open('/' + document.querySelector('html').getAttribute('lang') + '/teacher/' + document.querySelector('#modal_curator [name="id"]').value, '_blank');
    });
}

// Если страниц больше нет, но на десктопе мы некоторые записи скрыли, кнопка остается. Если страниц нет и записей скрытых тоже нет - кнопку удаляем
$('.js-paginate-desktop').each(function () {
    let btn = $(this),
        page = parseInt(btn.data('paginate-page') || '1'),
        selector = btn.data('paginate-selector'),
        pagesCount = btn.data('paginate-pages_count');

    if (typeof pagesCount !== 'undefined') {
        if (page === pagesCount) {
            let last_child = $(selector).children()[$(selector).children().length - 1];
            if ($(last_child).hasClass('hide') || $(last_child).is(":visible")) {
                btn.remove();
            }
        }
    }
});

$(document).on('click', '.js-paginate', function () { // .js-paginate-desktop - если разное кол-во на телефоне и компе
    let btn = $(this),
        action = btn.data('paginate-action'),
        page = parseInt(btn.data('paginate-page') || '1'),
        selector = btn.data('paginate-selector'),
        per_page = parseInt(btn.data('paginate-per_page') || '4'),
        desktop = $(window).width() > 992 && $(btn).hasClass('js-paginate-desktop'),
        showed = 0;
    if (desktop) {
        let last_child = $(selector).children()[$(selector).children().length - 1];
        if (!$(last_child).hasClass('hide') && !$(last_child).is(":visible")) {
            $($(selector).children()[$(selector).children().length - 1]).show();
            showed++;
        }
        showed += $(selector).find('.hide').length;
        $(selector).find('.hide').removeClass('hide');
        if (showed >= per_page - 1) {
            return false;
        }
    }
    if ($(selector).hasClass('paginate_end')) {
        btn.remove();
        return false;
    }
    btn.prop('disabled', true);
    $.post(action, {page: page + 1, width: $(window).width(), per_page: per_page}, function (response) {
        btn.prop('disabled', false);
        let hasMorePages = response.hasOwnProperty('hasMorePages') && response.hasMorePages;

        if (response.hasOwnProperty('items') && response.items) {
            $.each(response.items, function (k, item) {
                if (desktop && ++showed > per_page - 1) {
                    item = $(item).addClass('hide');
                }
                $(selector).append(item);

                if (typeof studentResultsMarginRecalculate === "function") {
                    studentResultsMarginRecalculate();
                }
            });
        }
        if (hasMorePages) {
            btn.data('paginate-page', page + 1);
        } else {
            $(selector).addClass('paginate_end');
            if (!$(selector).find('.hide').length) {
                btn.remove();
            }
        }

        feedback_position();

    }).fail(function () {
        $(selector).addClass('paginate_end');
        btn.remove();
    });
    return false;
});
$(document).on('click', '.js-like', function () {
    let $this = $(this);
    $.getJSON('/api/course_like/' + $(this).attr('data-id'), function (response) {
        if (response.hasOwnProperty('need_auth')) {
            $('#modalAuth').modal('show');
        } else {
            if (response.hasOwnProperty('count')) {
                $('.count-bookmarks').text(response.count);
            }
            $this.toggleClass('liked');
        }
    });

    return false;
});
$(document).on('click', '.show-lesson-module', function () {
    $(this).parent().next().show();

    return false;
});
$(document).on('click', '.hide-lesson-module', function () {
    $(this).closest('.lesson-module-toggle').hide();
    $(this).closest('.lesson-module-toggle').find('input').val('');
    return false;
});
$(document).on('change', '.poetap', function () {
    $(this).parent().parent().next().toggle();
});
$(document).on('change', '.toggle_lesson_free', function () {
    $(this).parent().parent().next().toggle();
    $(this).parent().parent().next().next().toggle();
    if (!$(this).is(':checked')) {
        $(this).parents('.form-group').find('.toggle_lesson_collapse:checked').click();
    }
    $(this).parents('.form-group').find('.toggle_lesson_secret:checked').click();
    $(this).parents('.form-group').find('.toggle_lesson_marathon:checked').click();
    update_courses_marathon_checkboxes();
});
$(document).on('change', '.toggle_lesson_secret', function () {
    $(this).parents('.form-group').find('.toggle_lesson_free:checked').click();
    $(this).parents('.form-group').find('.toggle_lesson_marathon:checked').click();
    update_courses_marathon_checkboxes();
});
$(document).on('change', '.toggle_lesson_marathon', function () {
    $(this).parents('.form-group').find('.toggle_lesson_free:checked').click();
    $(this).parents('.form-group').find('.toggle_lesson_secret:checked').click();
    if ($(this).is(':checked')) {
        $(this).parents('.form-group').find('.lesson_marathon_available_toggle').addClass('active');
    } else {
        $(this).parents('.form-group').find('.lesson_marathon_available_toggle').removeClass('active');
    }
    $(this).parents('.form-group').find('.toggle_lesson_marathon_available:checked').click();

    update_courses_marathon_checkboxes();
});

$(document).on('click', '.add-task-btn', function (e) {
    e.preventDefault();
    let task = $(this).data('task-number');
    $('#add-task-field-row-' + task).addClass('show');
    $('#add-task-btn-row-' + task).removeClass('show');
});

$(document).on('change', '.toggle_salary_game_slider', function () {
    $('.salary_game_slider_field_container').toggle();
});

$(document).ready(function () {
    let salary = parseInt($('.salary-game-slider-container').data('salary')),
        salaryJunior = parseInt($('.salary-game-slider-container').data('salary-junior')),
        salaryMiddle = parseInt($('.salary-game-slider-container').data('salary-middle')),
        salarySenior = parseInt($('.salary-game-slider-container').data('salary-senior')),
        salarySlogan = $('.salary-game-slider-container').data('salary-slogan'),
        salaryCurrencySymbol = $('.salary-game-slider-container').data('salary-currency-symbol'),
        startValue = (salarySenior + salary) / 2,
        $salaryGameInput = $('.salary-game-slider-input'),
        salaryGameInstance;


    let enableSalaryBlocks = function () {
        let fullRange = salarySenior - salary;
        if (salaryMiddle > 0) {
            let juniorBlockWidth = (salaryJunior - salary) * 100 / fullRange,
                middleBlockWidth = (salaryMiddle - salaryJunior) * 100 / fullRange,
                seniorBlockWidth = (salarySenior - salaryMiddle) * 100 / fullRange;
            $('.salary-junior-block').css('width', juniorBlockWidth + '%');
            $('.salary-middle-block').css('width', middleBlockWidth + '%');
            $('.salary-senior-block').css('width', seniorBlockWidth + '%');
        } else {
            $('.salary-middle-block').hide();
            let juniorBlockWidth = (salaryJunior - salary) * 100 / fullRange,
                seniorBlockWidth = (salarySenior - salaryJunior) * 100 / fullRange;
            $('.salary-junior-block').css('width', juniorBlockWidth + '%');
            $('.salary-senior-block').css('width', seniorBlockWidth + '%');
        }
    };

    let activateSalaryBlocks = function (currentValue) {
        $('.salary-game-slider-block').removeClass('active');
        $('.salary-game-slider .irs--custom .irs-single').removeClass('slogan');
        if (currentValue >= salary && currentValue <= salaryJunior) {
            $('.salary-junior-block').addClass('active');
        }
        if (currentValue > salaryJunior && currentValue <= salaryMiddle) {
            $('.salary-middle-block').addClass('active');
        }
        if (currentValue > salaryMiddle) {
            $('.salary-senior-block').addClass('active');
        }
        if (currentValue > salarySenior) {
            if (salarySlogan !== '') {
                $('.salary-game-slider .irs--custom .irs-single').html(salarySlogan);
                $('.salary-game-slider .irs--custom .irs-single').addClass('slogan');
            }
        }
    };

    let randomizeSalary = function (min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //Максимум не включается, минимум включается
    }

    $salaryGameInput.ionRangeSlider({
        min: salary,
        max: salarySenior + 1,
        from: startValue,
        step: 100,
        postfix: ' ' + salaryCurrencySymbol,
        skin: "custom",
        onStart: function (data) {
            enableSalaryBlocks();
            activateSalaryBlocks(data.from);
        },
        onChange: function (data) {
            activateSalaryBlocks(data.from);
        }
    });

    salaryGameInstance = $salaryGameInput.data('ionRangeSlider');

    $('.salary-game-slider-block span').click(function (e) {
        let sliderValue;
        if (salaryMiddle > 0) {
            switch ($(this).data('slider-target')) {
                case 'junior':
                    sliderValue = randomizeSalary(salary, salaryJunior);
                    break;
                case 'middle':
                    sliderValue = randomizeSalary(salaryJunior, salaryMiddle);
                    break;
                case 'senior':
                    sliderValue = randomizeSalary(salaryMiddle, salarySenior);
                    break;
            }
        } else {
            switch ($(this).data('slider-target')) {
                case 'junior':
                    sliderValue = randomizeSalary(salary, salaryJunior);
                    break;
                case 'senior':
                    sliderValue = randomizeSalary(salaryJunior, salarySenior);
                    break;
            }
        }


        salaryGameInstance.update({
            from: sliderValue
        });
        activateSalaryBlocks(sliderValue);
    });

    update_courses_marathon_checkboxes();
});


$(function () {
    if (location.hash.indexOf('program=') > -1) {
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
        let program = parseInt(location.hash.replace('#program=', ''));
        $('#program' + (program - 1) + '').collapse('show');

        $('html, body').animate({
            scrollTop: $('[href="#program' + (program - 1) + '"]').offset().top - TopOffset
        }, 600);
    }

    if (location.href.match(/\/course\//) || location.href.match(/webinar\//)) {
        if (typeof window.videojs !== 'undefined' && window.videojs.getAllPlayers().length) {
            var ModalDialog = videojs.getComponent('ModalDialog');
            window.videojs.getAllPlayers()[0].on('loadeddata', function (e) {
                console.log(e);
            });
            console.log(window.videojs.getAllPlayers());
            $.each(window.videojs.getAllPlayers(), function (key, player) {
                player.on('error', function (e) {
                    let el = document.createElement('div');
                    el.innerHTML = 'test';
                    console.log($(e.target).append(el));

                    var modal = new ModalDialog(player, {
                        content: $('html').attr('lang') === 'ru' ? 'Видео обрабатывается, ожидайте' : 'Video is being processed, please wait',
                        uncloseable: true,
                        // We don't want this modal to go away when it closes.
                        temporary: false
                    });
                    modal.addClass('vjs-modal-processed');
                    player.addChild(modal);
                    player.errorDisplay.close();

                    modal.open();

                });
            });

            $.each(window.videojs.getAllPlayers(), function (key, player) {
                player.volume(0.5);
            });
        }
    }


    $('form[data-ajax="1"] input[type="submit"], form[data-ajax="1"] button[type="submit"]').click(function (e) {
        const videoBlock = $('.videoLoadsBlock');
        videoBlock.html('');
        let videoLoads = localStorage.getItem('VideoLoads_' + $('meta[name="courseId"]').attr('content'));

        console.log(videoLoads);

        if (videoLoads === null) return;
        videoLoads = JSON.parse(videoLoads);

        for (let videoId of videoLoads) {
            let input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'ignoreVideo[]');
            input.setAttribute('value', videoId);

            videoBlock.append(input);
        }
    });
    $('.block-fast-message').submit(function () {
        let msg = $(this).find('.text-message');
        localStorage.setItem('fast-message-' + msg.data('course-id'), JSON.stringify(
            {
                message: msg.val(),
                timestamp: new Date().getTime()
            }
        ));
        if (msg.data('need-auth') === 1) {
            showAuthForm({redirect_after: msg.data('url')});
        } else {
            location.href = msg.data('url');
        }
        return false;
    });
});


if (location.href.match(/\/course\//)) {
    /*рассрочка ченджеры*/
    $('[name="rassrochkaprice_koeff"]').on('change', function () {
        var pds = $(this).parents('.course-price-block').find('[name="course_price"]:checked');

        var bd = delta_price == "0" ? null : delta_price;
        if (this.checked) {
            localStorage.setItem(course_id_pr + '_rassrochka', 1);
            localStorage.setItem(course_id_pr + '_rassrochkabg', 1);
            var rassr_info = (!isNaN(parseInt($('.rassr_info').attr('data-rassr'))) && $('.rassr_info').attr('data-rassr') > 0) ? parseInt($('.rassr_info').attr('data-rassr')) / 100 : 1;

            var withcurator = Math.ceil(parseInt(($('.course_price_calc_result').attr('data-default') ?? '').replace(/[^+\d]/g, '')) * rassr_info);
            $('.course_price_calc_result').text(numberWithSpaces(withcurator));

            var withoutcurator = Math.ceil(parseInt(($('.course_price_calc_result_without').attr('data-default') ?? '').replace(/[^+\d]/g, '')) * rassr_info);
            $('.course_price_calc_result_without').text(numberWithSpaces(withoutcurator));


            var withcurator_discount = Math.ceil(parseInt(($('.course_price_calc_result_discount:eq(0)').text() ?? '').replace(/[^+\d]/g, '')) * rassr_info);
            $('.course_price_calc_result_discount').text(numberWithSpaces(withcurator_discount));

            var withoutcurator_discount = Math.ceil(parseInt(($('.course_price_calc_result_without_discount:eq(0)').text() ?? '').replace(/[^+\d]/g, '')) * rassr_info);
            $('.course_price_calc_result_without_discount').text(numberWithSpaces(withoutcurator_discount));


        } else {
            localStorage.removeItem(course_id_pr + '_rassrochka');
            localStorage.setItem(course_id_pr + '_rassrochkabg', 1);
            $('.course_price_calc_result').text(bd ?? $('.course_price_calc_result').attr('data-default'));

            $('.course_price_calc_result_without').text(bd ?? $('.course_price_calc_result_without').attr('data-default'));


            $('.course_price_calc_result_discount').text(bd ?? $('.course_price_calc_result_discount').attr('data-default'));

            $('.course_price_calc_result_without_discount').text(bd ?? $('.course_price_calc_result_without_discount').attr('data-default'));

        }
        //зеленый нижний бар - пересчет
        bigatun = false;
        $('.type_buy').trigger('change');
        $(pds).click();
        console.log('pds', pds);
    });

    //$('[name="rassrochkaprice_koeff"]').change();
    /*рассрочка ченджеры*/
}
if (location.href.match(/\/course\//)) {
    console.log('itroe');
    if (localStorage.getItem(course_id_pr + '_rassrochka') == null && localStorage.getItem(course_id_pr + '_rassrochkabg') == null && $('[name="rassrochkaprice_koeff"]').is(':checked')) {
        $('.rassr_info').eq(0).click();
        $('.rassr_info').eq(0).click();
        $('[name="rassrochkaprice_koeff"]').prop('checked', true)
    } else if (localStorage.getItem(course_id_pr + '_rassrochka') == null) {
        $('.rassr_info').eq(0).click();
        $('[name="rassrochkaprice_koeff"]').prop('checked', false)
    } else {
        $('.rassr_info').eq(0).click();
        $('.rassr_info').eq(0).click();
        $('[name="rassrochkaprice_koeff"]').prop('checked', true)
    }
    $(window).on('load', function () {
        $('.rassr_info').eq(0).click();
        $('.rassr_info').eq(0).click();
        console.log('asd bbb');
    });
}
